import './UserButton.scss'
import Button from 'devextreme-react/button';
import { useState } from 'react';
import Popup from 'devextreme-react/popup';
import { Link } from 'react-router-dom';
import UserImage from './UserImage';
import Box, { Item } from 'devextreme-react/box';
import { useGetCurrentUserInformation } from '../../api/current-user';

export default function UserButton() {

	const currentUser = useGetCurrentUserInformation();
	const [isPopupVisible, setPopupVisibility] = useState(false);

	return (<>
		<Button
			className='user-button'
			onClick={() => setPopupVisibility(true)}
		>
			<UserImage userData={currentUser.data} imageSize={50} />
			<i className='dx-icon dx-icon-spindown'></i>
		</Button>
		<Popup
			visible={isPopupVisible}
			showTitle={false}
			hideOnOutsideClick={true}
			onHiding={() => setPopupVisibility(false)}
			width={360}
			height={240}
			shading={false}
			position={{ my: 'right top', at: 'right bottom', of: '.user-button', collision: 'none' }}
		>
			<div className='user-popup'>
				<Box>
					<Item baseSize={100}>
						<UserImage userData={currentUser.data} imageSize={100} />
					</Item>
					<Item ratio={1}>
						<div className='user-account'>
							<div className='user-name'>{currentUser.data?.firstName + ' ' + currentUser.data?.lastName}</div>
							<div>{currentUser.data?.emailAddress}</div>
						</div>
					</Item>
				</Box>
				<div className='user-menu'>
					<div>
						<Link to={'/profile'} onClick={() => setPopupVisibility(false)}>View Account</Link>
					</div>
					<div>
						<Link to={'/logout'} onClick={() => setPopupVisibility(false)}>Logout</Link>
					</div>
				</div>
			</div>
		</Popup>
	</>)
}